var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "sections" },
      [
        _c(
          "section",
          [
            _c("h3", [_vm._v("Bitte wähle den nächsten Schritt aus")]),
            _vm._v(" "),
            _c("RadioGroup", {
              attrs: { options: _vm.followUpOptions, stacked: "" },
              model: {
                value: _vm.followUp,
                callback: function($$v) {
                  _vm.followUp = $$v
                },
                expression: "followUp"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.followUpInterested
          ? _c(
              "section",
              [
                _c("h3", [
                  _vm._v(
                    "Interesse am besprochenen Job bei " +
                      _vm._s(_vm.companyName)
                  )
                ]),
                _vm._v(" "),
                _c("RadioGroup", {
                  attrs: { options: _vm.interestOptions, stacked: "" },
                  model: {
                    value: _vm.interest,
                    callback: function($$v) {
                      _vm.interest = $$v
                    },
                    expression: "interest"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.followUpSendoff
          ? _c("ApplicantSendOff", {
              staticClass: "mt-3",
              attrs: {
                customer: _vm.message.customer,
                "with-company-name": false,
                "is-anonymous": false
              },
              model: {
                value: _vm.sendOffData,
                callback: function($$v) {
                  _vm.sendOffData = $$v
                },
                expression: "sendOffData"
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt-3 text-right" },
          [
            _c("Button", {
              attrs: {
                text: "Senden",
                icon: "checkmark",
                disabled: !_vm.dataValid || _vm.sendingRequest,
                loading: _vm.sendingRequest
              },
              on: { click: _vm.submit }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }